import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { asset } from '@/lib/api';
import { Icon } from '@/components/Icons';
import { SectionHeading } from '@/components/SectionHeading';
import { RevealGroup, RevealItem } from '@/components/Reveal';
import { MagneticButton } from '@/components/MagneticButton';

export const ServicesPreview = ({ services = [] }) => {
  const featured = services.filter((s) => s.featured).slice(0, 6);
  const list = featured.length ? featured : services.slice(0, 6);
  return (
    <section className='relative bg-[#20272A]'>
      <div className='grain absolute inset-0' />
      <div className='relative container-x py-20 lg:py-28'>
        <div className='flex flex-col justify-between gap-6 md:flex-row md:items-end'>
          <SectionHeading eyebrow='Our Services' title='From ground preparation to complex earthworks.' light />
          <MagneticButton to='/services' variant='secondary' className='text-[#F6F5F1] shrink-0' data-cursor='EXPLORE'>
            All Services
          </MagneticButton>
        </div>

        <RevealGroup className='mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3'>
          {list.map((s) => (
            <RevealItem key={s.slug}>
              <Link
                to={`/services/${s.slug}`}
                data-testid='service-card'
                data-cursor='EXPLORE'
                className='group relative block h-[320px] overflow-hidden rounded-2xl border border-white/10'
              >
                <img
                  src={asset(s.image)}
                  alt={s.title}
                  className='absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105'
                />
                <div className='absolute inset-0' style={{ background: 'linear-gradient(180deg, rgba(32,39,42,0.15) 0%, rgba(32,39,42,0.55) 55%, rgba(32,39,42,0.95) 100%)' }} />
                <span className='absolute left-0 top-0 h-full w-[2px] origin-top scale-y-0 bg-[#B88A3B] transition-transform duration-500 group-hover:scale-y-100' />
                <div className='absolute inset-x-0 bottom-0 p-6'>
                  <div className='flex items-center gap-2 text-[#B88A3B]'>
                    <Icon name={s.icon} size={20} />
                    <span className='eyebrow text-[10px] text-[#F6F5F1]/60'>{s.category}</span>
                  </div>
                  <div className='mt-3 flex items-center justify-between'>
                    <h3 className='font-head text-2xl font-semibold text-[#F6F5F1]'>{s.title}</h3>
                    <span className='translate-x-1 text-[#F6F5F1]/60 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:text-[#B88A3B] group-hover:opacity-100'>
                      <ArrowUpRight size={22} />
                    </span>
                  </div>
                  <p className='mt-2 max-h-0 overflow-hidden text-sm text-[#F6F5F1]/70 opacity-0 transition-all duration-500 group-hover:max-h-24 group-hover:opacity-100'>
                    {s.tagline}
                  </p>
                </div>
              </Link>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
};
